import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData, { GAME_IMAGES_KEY } from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class HudDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.xes = [];

    this.lblScore = ABCyaPhaser.Text.addText(20,10, '32pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, 'SCORE 0', this).setOrigin(0);

    this.lblTimeLeft = ABCyaPhaser.Text.addText(20,50, '32pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, 'TIME 60', this).setOrigin(0);

    this.msgBoard = ABCyaPhaser.Images.addImage(0,0,'TopDisplayBoardBg', this, GAME_IMAGES_KEY).setOrigin(0);
    this.msgBoard.x = this.scene.scale.width / 2 - this.msgBoard.width / 2;

    this.lblMsg = ABCyaPhaser.Text.addText(this.msgBoard.x + this.msgBoard.width / 2 - 8, this.msgBoard.y + this.msgBoard.height / 2 - 30, '32pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, 'HIYA', this).setOrigin(0.5, 0);

    this.badHitDisplay = this.scene.add.container();
    let curX = 0;
    for (let i = 0; i < 3; i++) {
      const item = ABCyaPhaser.Images.addImage(curX,0,UIAssetKeys._XIndicator, this.badHitDisplay).setAlpha(0);
      curX += item.width - 20;// - is shadow png space
      this.xes.push(item);
    }
    this.add(this.badHitDisplay);
    this.badHitDisplay.x = 880;
    this.badHitDisplay.y = 40;

    this.timesUpDisplay = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._TimesUpDisplay, this).setVisible(false);
    this.timesUpDisplay.x = this.scene.scale.width / 2;
    this.timesUpDisplay.y = this.scene.scale.height / 2;
  }

  hideTimesUp () {
    this.timesUpDisplay.alpha = 0;
  }

  showWrong (index) {
    const x = this.xes[index];
    if (!x) return;
    x.scale = 1.7;
    x.alpha = 0;
    ABCyaPhaser.Tweens.addTween(x, 330, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.In);
  }

  fadeOut (waittime = 0) {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 200, { delay: waittime, alpha: 0 }, Phaser.Math.Easing.Linear);
  }

  updateLabel (value) {
    this.lblMsg.text = value.toUpperCase();
  }

  setTimeLeft (value) {
    this.lblTimeLeft.text = `TIME ${value}`;
  }

  showTimesUp () {
    this.timesUpDisplay.setVisible(true);
    this.timesUpDisplay.scale = 0;
    this.timesUpDisplay.alpha = 0;
    this.scene.tweens.killTweensOf(this.timesUpDisplay);
    ABCyaPhaser.Tweens.addTween(this.timesUpDisplay, 700, { alpha: 1, scale: 1, completeDelay: 1200 }, Phaser.Math.Easing.Linear, () => this.timesUpComplete());
  }

  timesUpComplete () {
    this.emit('TIMES_UP_COMPLETE');
  }

  updateScore (value) {
    this.lblScore.text = `SCORE ${value}`;
  }

  reset () {
    const len = this.xes.length;
    for (let i = 0; i < len; i++) {
      this.xes[i].alpha = 0;
    }
    this.lblScore.text = 'SCORE 0';
    this.fadeIn();
  }

  fadeIn () {
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 200, { alpha: 1 }, Phaser.Math.Easing.Linear);
  }
}